<div class="flex justify-between align-middle">
	<h4 class="mb-5">Edit {{ data.officeName }} {{ data.mode }}</h4>
	<div *ngIf="data.mode === 'letterhead'">
		<app-button btn="secondary" size="small" (click)="resetLetterhead()"
			>Revert to default</app-button
		>
	</div>
</div>

<div *ngIf="footer || letterhead" class="flex flex-col">
	<ng-container *ngIf="data.mode === 'footer'">
		<div *ngIf="footer.first.matches" [@openClose]>
			<app-checkbox
				type="clear"
				label="Show footer"
				[(ngModel)]="globalFooter"
				(ngModelChange)="toggleFootersEnablement()"
			></app-checkbox>
		</div>
		<div
			class="mt-5 flex justify-between align-top mb-2"
			*ngIf="globalFooter"
			[@openClose]
		>
			<div>
				<app-checkbox
					type="default"
					label="Same footer for all pages"
					[(ngModel)]="footer.first.matches"
					(ngModelChange)="switchFooter(FooterName.GLOBAL)"
				></app-checkbox>
			</div>
			<div *ngIf="footer.first.matches" [@fade]>
				<app-button btn="secondary" (click)="resetLetterhead()"
					>Revert to default</app-button
				>
			</div>
		</div>
		<div class="mb-3 mt-3" *ngIf="!footer.first.matches" [@openClose]>
			<atomic-button-group
				[(ngModel)]="currentFooter"
				(ngModelChange)="switchFooter($event)"
				[options]="footers"
			></atomic-button-group>
		</div>
		<div *ngIf="!footer.first.matches" [@openClose] class="my-3">
			<div class="flex justify-between align-middle">
				<app-checkbox
					type="clear"
					label="Show footer in {{
						currentFooter === FooterName.FIRST
							? 'first page'
							: 'all other pages'
					}}"
					[(ngModel)]="footer[currentFooter].enabled"
					(ngModelChange)="setGlobalFooterSwitch()"
				></app-checkbox>
				<div *ngIf="!footer.first.matches">
					<app-button btn="secondary" size="small" (click)="resetLetterhead()"
						>Revert to default</app-button
					>
				</div>
			</div>
		</div>
		<div *ngIf="!footer.first.matches" class="my-6">
			<atomic-message-bar type="info" class="block px-3"
				>Please note that the tallest footer will set the height of the footer
				block on all pages</atomic-message-bar
			>
		</div>
	</ng-container>

	<div class="content-editor-wrapper">
		<editor
			[disabled]="
				data.mode === 'footer' &&
				(!footer[currentFooter].enabled ||
					(currentFooter === FooterName.FIRST && footer.first.matches))
			"
			[init]="tmceInit"
			[initialValue]="letterhead"
			[ngModel]="content"
			(ngModelChange)="waitForRender($event)"
		></editor>

		<app-html-pdf-viewer
			[html]="content"
			(finishedRendering)="finishedRendering($event)"
		>
		</app-html-pdf-viewer>
	</div>
</div>

<div class="flex justify-between pb-5 mr-5 mt-10">
	<app-button btn="tertiary" class="mr-5" (click)="cancelModal()" size="small"
		>Cancel</app-button
	>
	<app-button
		size="small"
		(click)="saveLetterhead()"
		[loading]="busy"
		[disabled]="busy"
		>{{ save ? 'Saving...' : busy ? 'Busy...' : 'Save' }}</app-button
	>
</div>
